<template>
    <div class="login-bg" ref="login">
        <transition name="bounce">
            <el-form class="login-form" :model="form" :class="{'bounce-enter-active':show}">
                <h3>乐纯CMS后台系统</h3>
                <img src="../assets/images/login-icon.png">
                <el-form-item>
                    <el-input placeholder="请输入账号" v-model="form.userName"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input type="password" placeholder="请输入密码" v-model="form.passWord"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary"  @click="login(form)" class="login-btn">登录</el-button>
                </el-form-item>
            </el-form>
        </transition>
        <ParticlesJs></ParticlesJs>
    </div>
</template>

<script>
    //导入 HTTP请求方法
    import {login} from '@/api/api'
    import {getmd5} from '@/global/globalMethod'
    import ParticlesJs from '@/components/particles_js/particles_js'

    export default{
        data(){
            return{
                form:{
                    userName:'',
                    passWord:''
                },
                show:false
            }
        },
        components:{
            ParticlesJs
        },
        mounted(){
             let _this = this
            this.$refs.login.onkeydown = function(e) {
                e = e || window.event;
                if(e.keyCode == 13) {
                    _this.login(_this.form)
                }
            }
        },
        methods:{
            login(form){
                const _this = this;
                login({userName:form.userName,passWord:getmd5(form.passWord)}).then((res) => {
                    if(res.data.status==200){
                        this.show = false;
                        this.$message({
                            showClose: true,
                            message: '登录成功',
                            type: 'success'
                        });
                        //记住当前登录用户名
                        window.localStorage.setItem('loginUser',form.userName);
                        //this.$router.push('dashboard')
                        if (this.$route.query.auth=="0"){
                            this.$router.go(-1);
                        }else {
                            this.$router.push('dashboard')
                        }
                    }else{
                        this.show = true;
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error',
                            onClose:function () {

                            }
                        });
                    }
                })
            }
        }
    }
</script>

<style lang="scss" rel="stylesheet/scss">
    .login-bg{
        height: 100%;
        width: 100%;
        position: absolute;
        top:0;
        left: 0;
        background: url("../assets/images/login-bg.jpg") top left no-repeat;
        background-size: 100% 100%;
        .login-form{
            position: absolute;
            top:50%;
            left: 50%;
            margin: -240px 0 0 -220px;
            width: 440px;
            border:1px solid #ffffff;
            border-radius: 20px;
            img{
                margin: 0 auto 20px;
                display: block;
            }
        }
        .login-form h3{
            text-align: center;
            font-size: 30px;
            color: #ffffff;
        }
        .login-btn{
            width: 100%;
            display: block;
            margin: 0 auto;
        }
        .el-button--primary{
            border-color: #ffffff;
            background-color: rgba(255,255,255,.6);
            border-radius: 28px;
            color: #ffffff;
            font-size: 20px;
        }
        .el-form-item{
            margin: 0 20px 22px;
        }
        input{
            background-color: transparent;
            border-radius: 20px;
            font-size: 16px;
            color: #ffffff;
        }
        input:-webkit-autofill{
            -webkit-box-shadow: 0 0 0px 1000px #ffffff inset;
        }
        .el-input.is-active .el-input__inner, .el-input__inner:focus{
            border-color: #ffffff;
        }
        .el-input__inner:hover{
            box-shadow: 0 0 6px #ffffff;
        }
        .bounce-enter-active {
            animation: shake-in .5s ease;
        }
        @keyframes bounce-in {
            0% {
                transform: scale(1);
            }
            50% {
                transform: scale(1.5);
            }
            100% {
                transform: scale(1);
            }
        }
        @keyframes shake-in {
            0%{transform:translateX(0)}
            6.5%{transform:translateX(-6px) rotateY(-9deg)}
            18.5%{transform:translateX(5px) rotateY(7deg)}
            31.5%{transform:translateX(-3px) rotateY(-5deg)}
            43.5%{transform:translateX(2px) rotateY(3deg)}
            50%{transform:translateX(0)}
        }
    }


</style>


// WEBPACK FOOTER //
// src/views/Login.vue